import React, { useState } from 'react'
import { Menu, MenuItem, MenuList, Paper } from '@mui/material'
import { MoreButton } from 'common/Button/MoreButton'
import TextColorFontBody from 'common/Typography/TextColorFontBody'
import circlesOrbitColorPalette from 'common/ui/circlesColorTheme'
import { DistributorPromocodeDetails } from 'types/api/faber/reward.type'

import DistributorUpdateDialog from './DistributorUpdateDialog'
import PromocodeUsersDialog from './PromocodeUsersDialog'
interface Props {
  row: DistributorPromocodeDetails
  promocode: string
  openDialog: boolean
  handleCloseDialog: () => void
  handleViewUsersClick: (promocode: string) => void
}

const DistributorActionMenu = ({
  row,
  promocode,
  openDialog,
  handleCloseDialog,
  handleViewUsersClick
}: Props) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)
  const handleMenuOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleMenuClose = () => {
    setAnchorEl(null)
  }

  const [updateDialogOpen, setUpdateDialogOpen] = useState(false)

  const handleUpdateDialogOpen = () => {
    setUpdateDialogOpen(true)
  }

  const handleDialogClose = () => {
    setUpdateDialogOpen(false)
  }

  return (
    <>
      <MoreButton onClick={handleMenuOpen} />
      <Paper>
        <MenuList dense>
          <Menu
            id='action-menu'
            anchorEl={anchorEl}
            open={open}
            onClose={handleMenuClose}
            MenuListProps={{
              'aria-labelledby': 'basic-button'
            }}
          >
            <MenuItem onClick={() => handleUpdateDialogOpen()}>
              <TextColorFontBody
                sx={{
                  color: circlesOrbitColorPalette.neutrals[600],
                  fontSize: '12px'
                }}
              >
                Update
              </TextColorFontBody>
            </MenuItem>
            <MenuItem onClick={() => handleViewUsersClick(row.promocode)}>
              <TextColorFontBody
                sx={{
                  color: circlesOrbitColorPalette.neutrals[600],
                  fontSize: '12px'
                }}
              >
                View consumers
              </TextColorFontBody>
            </MenuItem>
            <DistributorUpdateDialog
              distributorPromoRow={row}
              handleDialogClose={handleDialogClose}
              openDialog={updateDialogOpen}
              handleMenuClose={handleMenuClose}
            />
            {promocode && (
              <PromocodeUsersDialog
                promocode={promocode}
                openDialog={openDialog}
                handleCloseDialog={handleCloseDialog}
              />
            )}
          </Menu>
        </MenuList>
      </Paper>
    </>
  )
}

export default DistributorActionMenu
